import {
  Divider,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@material-ui/lab";
import SanitizedGrid from "components/SanitizedGrid";
import get from "lodash/get";
import moment from "moment";
import PassengerDetailModal from "./PassengerDetailModal";

const useStyles = makeStyles({
  paper: {
    padding: "6px 16px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  removeOppositeContent: {
    "& .MuiTimelineItem-missingOppositeContent:before": {
      flex: 0,
      content: "",
      padding: 0,
    },
  },
  timelineDot: { backgroundColor: "#4caf50" },
  timelineDotText: {
    width: "35px",
    height: "35px",
    textAlign: "center",
    lineHeight: "2.3",
  },
  address: {
    marginTop: 5,
  },
});

const CustomTimelineBusServices = ({
  record = {},
  source,
  assignmentId,
}: any) => {
  const classes = useStyles();

  const locations = get(record, source);
  const routeType = get(record, "routeType");
  const school = get(record, "school");
  const startTime = get(record, "startTime");
  const endTime = get(record, "endTime");

  const startedAt = get(record, "startedAt");
  const endedAt = get(record, "endedAt");

  return (
    <Timeline className={classes.removeOppositeContent}>
      {(routeType === "from_school" || routeType === "cca") && (
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot className={classes.timelineDot}>
              <Typography className={classes.timelineDotText}>S</Typography>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper className={classes.paper}>
              <SanitizedGrid container spacing={2}>
                <Grid item xs={4}>
                  <Typography variant="h6">{startTime}</Typography>
                </Grid>

                <Grid item xs={8}>
                  <Typography variant="subtitle2" className={classes.address}>
                    {school.address}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom>
                    {school.name}
                  </Typography>

                  <Typography variant="body2" gutterBottom>
                    <Divider />
                  </Typography>

                  <Typography variant="caption" display="block" gutterBottom>
                    Started At :{" "}
                    {(() => {
                      if (!startedAt) {
                        return "-";
                      }

                      return moment(startedAt).format("hh:mm A");
                    })()}
                  </Typography>
                </Grid>
              </SanitizedGrid>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      )}

      {locations &&
        locations.map((location: IAssignmentLocation, key: number) => {
          return (
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot className={classes.timelineDot}>
                  <Typography className={classes.timelineDotText}>
                    {location.order}
                  </Typography>
                </TimelineDot>
                {locations.length === key + 1 &&
                (routeType === "from_school" || routeType === "cca") ? (
                  <></>
                ) : (
                  <TimelineConnector />
                )}
              </TimelineSeparator>
              <TimelineContent>
                <Paper className={classes.paper}>
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={4}>
                      <Typography variant="h6">{location.arrivAt}</Typography>
                    </Grid>

                    <Grid item xs={8}>
                      <Typography
                        variant="subtitle2"
                        className={classes.address}
                      >
                        {location.address}
                      </Typography>

                      {location.remark && (
                        <Typography
                          variant="subtitle2"
                          className={classes.address}
                        >
                          {`(${location.remark})`}
                        </Typography>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    {location.passengers.map(
                      (passenger: IAssignmentPassenger) => {
                        return (
                          <PassengerDetailModal
                            assignmentId={assignmentId}
                            assignmentLocation={location}
                            assignmentPassenger={passenger}
                          />
                        );
                      },
                    )}
                  </SanitizedGrid>
                </Paper>
              </TimelineContent>
            </TimelineItem>
          );
        })}

      {routeType === "to_school" && (
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot className={classes.timelineDot}>
              <Typography className={classes.timelineDotText}>E</Typography>
            </TimelineDot>
          </TimelineSeparator>
          <TimelineContent>
            <Paper className={classes.paper}>
              <SanitizedGrid container spacing={2}>
                <Grid item xs={4}>
                  <Typography variant="h6">{endTime}</Typography>
                </Grid>

                <Grid item xs={8}>
                  <Typography variant="subtitle2" className={classes.address}>
                    {school.address}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle2" gutterBottom>
                    {school.name}
                  </Typography>

                  <Typography variant="body2" gutterBottom>
                    <Divider />
                  </Typography>

                  <Typography variant="caption" display="block" gutterBottom>
                    Ended At :{" "}
                    {(() => {
                      if (!endedAt) {
                        return "-";
                      }

                      return moment(endedAt).format("hh:mm A");
                    })()}
                  </Typography>
                </Grid>
              </SanitizedGrid>
            </Paper>
          </TimelineContent>
        </TimelineItem>
      )}
    </Timeline>
  );
};

export default CustomTimelineBusServices;
